import { connect } from 'react-redux';
import { getPaginationUrl } from 'shared/components/Paginator';
import withRouter from 'shared/helper/with-router';
import { archiveDigitalEdit, createDigitalEdit, getDownloadUrl, searchDigitalEdits, updateDisplayedDigitalEdits } from '../actions';
import { getDigitalEdits } from '../reducer';
import ManageDigitalEdits from './ManageDigitalEdits';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var digitalEdit = _ref.digitalEdit,
    user = _ref.user;
  var location = _ref2.location,
    digitalEditingTrialEnabled = _ref2.digitalEditingTrialEnabled;
  return {
    digitalEditEnabled: digitalEdit.hasDigitalEditingPurchase,
    digitalEdits: getDigitalEdits({
      digitalEdit: digitalEdit
    }),
    digitalEditingTrialEnabled: digitalEditingTrialEnabled,
    pagination: digitalEdit.pagination,
    paginationUrl: getPaginationUrl({
      location: location
    }),
    pathname: location.pathname,
    status: digitalEdit.status,
    uuid: user.identity
  };
};
var mapDispatchToProps = {
  archiveDigitalEdit: archiveDigitalEdit,
  createDigitalEdit: createDigitalEdit,
  getDownloadUrl: getDownloadUrl,
  searchDigitalEdits: searchDigitalEdits,
  updateDisplayedDigitalEdits: updateDisplayedDigitalEdits
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageDigitalEdits));